module.exports = __webpack_public_path__ + "img/0Q3B3739_Wood.8a6a5e6b.jpg";